module.exports = __webpack_public_path__ + "img/4.fcdb740e.png";